<ng-template #attente>
  <br>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div *ngIf="enregistrementTerminer;else attente"></div>
<mat-card class="example-card">
  <mat-card-header>
    <mat-card-title><span style="color: blue">Liste images déroulantes 950 / 400 </span></mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="example-button-row">
      <button matTooltip="Ajouter" style="margin-right: 10px" mat-icon-button [disabled]="buttonDisabled"
        (click)="importer('666_450')" color="primary">
        <mat-icon>cloud_upload</mat-icon>
      </button>
      <button matTooltip="Modifier" mat-icon-button [disabled]="buttonDisabled" (click)="importer('modifier_666_450')"
        color="primary">
        <mat-icon>edit</mat-icon>
      </button>
      <button matTooltip="Ajouter" mat-icon-button [disabled]="buttonDisabled" (click)="ajouterArticle1()"
        color="primary">
        <mat-icon>swap_horiz</mat-icon>
      </button>
      <button matTooltip="Enregistrer" mat-icon-button [disabled]="buttonDisabled" (click)="enregistrerTextImage()"
        color="primary">
        <mat-icon>save</mat-icon>
      </button>
      <button matTooltip="Supprimer" mat-icon-button [disabled]="buttonDisabled" (click)="supprimer()" color="primary">
        <mat-icon>delete</mat-icon>
      </button>
      <input id="input_666_450" type="file" style="display:none;" (change)="onChangeImagefile($event,'ajouterBannier')">
      <input id="input_modifier_666_450" type="file" style="display:none;"
        (change)="onChangeImagefile($event,'modifierBannier')">
    </div>
    <div class="display-flex">
      <div *ngFor="let img of listeImages;let i = index" class="width-img div-img">
        <img [id]="img.File_Id" class="width-img" (click)="selectImageDeatail(img.File_Id,i)"
          [src]="(useDataBaseToSaveImage == 1? img.File_Content : (base_url +'images/')) + img.File_Content">

        <mat-form-field class="width-input">
          <input (focus)="selectImageDeatail(img.File_Id,i)" matInput [name]="'File_Text'+img.File_Id"
            [(ngModel)]="img.File_Text" placeholder="Français">
        </mat-form-field>
        <mat-form-field class="width-100">
          <input (focus)="selectImageDeatail(img.File_Id,i)" matInput [name]="'File_Class2'+img.File_Id"
            [(ngModel)]="img.textAnglais" placeholder="Anglais">
        </mat-form-field>
      </div>
    </div>
    <div>
      <app-liste #listeComponen [showFilter]="false" [heightTable]="'400'" [displayedColumnsBrut]="columns"
        [listBtn]="listBtn" (btnTable)="clickBtnHeat($event)">
      </app-liste>
    </div>

  </mat-card-content>
</mat-card>
<br>
<div class="banners">
  <mat-card class="width">
    <mat-card-header>
      <mat-card-title><span style="color: blue ;">Image fixe 234 / 450</span></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="wrapper" style="display: flex;justify-content: space-around;">
        <div>
          <span style="font-weight: bold;color: blue">Image 1</span>
          <div style="cursor: pointer" (click)="importer('1_234_450')">
            <img id="1_234_450"
              [src]="(useDataBaseToSaveImage == 1? img_1_234_450.File_Content : (base_url +'images/')) + img_1_234_450.File_Content"
              width="100px" height="122px">
            <div>
            </div>
            <input id="input_1_234_450" type="file" style="display:none;"
              (change)="onChangeImagefile($event,'enregistrerImageFixe1')">
          </div>
        </div>

        <div>
          <span style="font-weight: bold;color: blue">Image 2</span>
          <div style="cursor: pointer" (click)="importer('2_234_450')">
            <img id="2_234_450"
              [src]="(useDataBaseToSaveImage == 1? img_2_234_450.File_Content : (base_url +'images/')) + img_2_234_450.File_Content"
              width="100px" height="122px">
            <div>
            </div>
            <input id="input_2_234_450" type="file" style="display:none;"
              (change)="onChangeImagefile($event,'enregistrerImageFixe2')">
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card class="width" *ngIf="generalService.cuurentUser=='SNCT'">
    <mat-card-header>
      <mat-card-title><span style="color: blue">Banniére 415 / 260</span></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="wrapper" style="display: flex;justify-content: space-around;">
        <div>
          <span style="font-weight: bold;color: blue">Banniére 1 </span>
          <div style="cursor: pointer" (click)="importer('banniere2.1')">
            <img id="banniere2.1"
              [src]="(useDataBaseToSaveImage == 1? Banner1.File_Content : (base_url +'images/')) + Banner1.File_Content"
              width="200px" height="122px">
            <div>
            </div>
            <input id="input_banniere2.1" type="file" style="display:none;"
              (change)="onChangeImagefile($event,'enregistrerBanner2.1')">
          </div>
        </div>

        <div>
          <span style="font-weight: bold;color: blue">Banniére 2 </span>
          <div style="cursor: pointer" (click)="importer('banniere2.2')">
            <img id="banniere2.2"
              [src]="(useDataBaseToSaveImage == 1? Banner2.File_Content : (base_url +'images/')) + Banner2.File_Content"
              width="200px" height="122px">
            <div>
            </div>
            <input id="input_banniere2.2" type="file" style="display:none;"
              (change)="onChangeImagefile($event,'enregistrerBanner2.2')">
          </div>
          <mat-form-field class="width-input">
            <input (focus)="onFocusInput()" (blur)="updateLienBanner2()" matInput [(ngModel)]="Banner2.File_Lien" placeholder="Url categorie">
          </mat-form-field>
          <div>

          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
